/* eslint-disable no-useless-escape */
export const DropdownTypes = {
  SINGLE_SELECTION: 'singleSelection',
  MULTI_SELECTION: 'multiSelection'
};
export const OptionTypes = {
  COLLAPSABLE_LIST: 'collapsableList',
  SECTION_LIST: 'sectionList',
  COLLAPSABLE_LIST_WITH_CHECKBOXES: 'collapsableListWithCheckboxes'
};
export const searchMetaData = {
  selectAllText: '',
  selectAllResultsText: '',
  get getSelectAllText() {
    return this.selectAllText;
  },
  set setSelectAllText(text) {
    if (text) this.selectAllText = text;
  },
  get getSelectAllResultsText() {
    return this.selectAllResultsText;
  },
  set setSelectAllResultsText(text) {
    if (text) this.selectAllResultsText = text;
  }
};
export const SelectAllText = 'Select all';
export const SelectAllResultsText = 'Select all results';
export const generateItemKey = (folderIndex, itemIndex) => `${folderIndex}_FI_${itemIndex}`;
export const defaultSelectedValue = placeHolder => ({
  label: placeHolder,
  value: ''
});
export const highLightedLabel = (label, searchValue) => {
  if (typeof searchValue === 'string') {
    searchValue = searchValue.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  }
  return label.replace(new RegExp(searchValue, 'gim'), `<mark class="sib-highlight">$&</mark>`);
};
export const removePlaceholder = (selectedValues, placeHolder) => {
  return selectedValues.filter(_ref => {
    let {
      label
    } = _ref;
    return label != placeHolder;
  });
};
export const filterDisabledItems = items => items.filter(item => !(item.disabled === true));
export const filterOutItems = (selectedValues, items) => selectedValues.filter(selectedValue => !items.some(item => {
  const {
    label,
    value,
    key
  } = selectedValue;
  if (key && item.key) {
    return label === item.label && key === item.key;
  } else {
    return label === item.label && value === item.value;
  }
}));
export const searchedText = (searchValue, options) => {
  if (searchValue) {
    options = options.reduce(function (result, option, folderIndex) {
      const {
        type
      } = option || {};
      if (type === OptionTypes.COLLAPSABLE_LIST) {
        const {
          items
        } = option;
        const newItems = items.map((item, index) => ({
          highLightedLabel: highLightedLabel(item.label, searchValue),
          key: item?.key || generateItemKey(folderIndex, index),
          ...item
        })).filter(item => {
          const {
            label,
            disabled
          } = item;
          return label && label.toLowerCase().includes(searchValue.toLowerCase()) && !disabled;
        });
        return result.concat(newItems);
      } else {
        const {
          label,
          disabled
        } = option;
        if (label && label.toLowerCase().includes(searchValue.toLowerCase()) && !disabled) {
          return result.concat({
            highLightedLabel: highLightedLabel(label, searchValue),
            ...option,
            key: option.key || folderIndex
          });
        }
        return result;
      }
    }, []);
  }
  return [...options];
};